/**
 * Subjects Service
 * Handles fetching subject data
 */

import { httpClient } from '../lib/httpClient';
import { globalConfig } from '../config/globalConfig';
import type { SubjectsResponse, SubjectsQueryParams } from '../interfaces/apiInterfaces/subjects';

/**
 * Fetch subjects list with optional filters
 * @param params - Query parameters for filtering, pagination
 * @returns Subjects list with pagination info
 */
export async function fetchSubjects(params?: SubjectsQueryParams): Promise<SubjectsResponse> {
  try {
    // Fetch all subjects by setting large page size
    const defaultParams: SubjectsQueryParams = {
      page_number: globalConfig.defaultPageNumber,
      page_size: globalConfig.defaultPageSize,
      ...params,
    };
    const response = await httpClient.get<SubjectsResponse>(
      '/v1/subjects',
      { params: defaultParams }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching subjects:', error);
    throw error;
  }
}
